import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookOpen, Menu, X } from "lucide-react";

const NAV = [
  { to: "/magazines", label: "Magazines" },
  { to: "/publishers", label: "Publishers" },
  { to: "/pricing", label: "Subscriptions" },
  { to: "/blog", label: "Journal" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-bm-cream/95 backdrop-blur-xl border-b border-bm-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5">
          <BookOpen className="w-7 h-7 text-bm-terra" strokeWidth={1.8} />
          <span className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-bm-ink">BookMala</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `relative text-sm font-medium tracking-wide transition-colors duration-200 after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:bg-bm-terra after:transition-all after:duration-200 ${
                  isActive ? "text-bm-terra after:w-full" : "text-bm-body hover:text-bm-terra after:w-0 hover:after:w-full"}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/pricing" data-testid="header-subscribe-cta" className="btn-primary !px-6 !py-2.5 !text-sm">
            Subscribe Now
          </Link>
        </nav>
        <button className="lg:hidden text-bm-ink" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-bm-line bg-bm-cream px-6 py-6 flex flex-col gap-5" data-testid="mobile-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className="text-base font-medium text-bm-body hover:text-bm-terra transition-colors duration-200">
              {n.label}
            </NavLink>
          ))}
          <Link to="/pricing" onClick={() => setOpen(false)} data-testid="mobile-subscribe-cta" className="btn-primary w-full">
            Subscribe Now
          </Link>
        </nav>
      )}
    </header>
  );
};
